import callAPiBase from './base';

const turnstilesApi = {
  get: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripReport',
      method: 'POST',
      useToken: true,
      title: 'turnstiles - Get List',
      data,
    }),
};

export { turnstilesApi };
export default turnstilesApi;
